import dateUtil from "./dateUtil";

const formatDateFromTimestamp = (timestamp) => {
  if (timestamp) {
    const date = new Date(timestamp);

    const day = date.getDate();
    const year = date.getFullYear();

    const hours = date.getHours();
    const minutes = date.getMinutes();

    const monthName = dateUtil.getMonthName(date);
    const isCurrentYear = dateUtil.isCurrentYear(date);

    const result = `${day} ${monthName}, ${
      !isCurrentYear ? `${year},` : ""
    } ${dateUtil.addLeadingZero(hours)}:${dateUtil.addLeadingZero(minutes)}`;

    return result;
  }
};

const changeHistoryUtils = {
  formatDateFromTimestamp
};

export default changeHistoryUtils;
